var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2TvRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h11V42H56v22zm4.5-18h2a1.5 1.5 0 110 3h-2a1.5 1.5 0 110-3zm0 6h2a1.5 1.5 0 110 3h-2a1.5 1.5 0 110-3zM67 19v18h-4V19H13v28h38v4H40v9h11v4H25v-4h11v-9H13a4 4 0 01-4-4V19a4 4 0 014-4h50a4 4 0 014 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_TV_room_bis.ed3c0084.svg";
export { SvgE2TvRoomBis as ReactComponent };